import React, { useState,useRef, useEffect } from "react";
import axios from "axios";
import { FaCloudUploadAlt } from 'react-icons/fa';
import CandidateDashboardNav from '../../candidate/CandidateDashboardNav'
import SuccessModal from "../../shared/SuccessModal";
import ProfileModal from "../../shared/ProfileModal";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../Breadcrumb";

const CV_Manager = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false); 
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    message: "",
    redirectPath: "/myprofile",
  });

  const checkProfileCompleteness = async () => {
    const userId = localStorage.getItem("userid");
  
    if (!userId || userId === "null" || userId === "undefined") {
      setModalConfig({
        message: "User ID not found. Please log in again.",
        redirectPath: "/login",
      });
      setShowProfileModal(true);
      return;
    }
  
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}candidate_details/showcandidatebyid/${userId}`
      );
  
      if (!response.data || response.data.length === 0) {
        setModalConfig({
          message: "Please complete your profile before uploading your CV.",
          redirectPath: "/myprofile",
        });
        setShowProfileModal(true);
      }
  
    } catch (error) {
      if (error.response?.status === 404) {
        setModalConfig({
          message: "Profile not found. Please complete your profile first.",
          redirectPath: "/myprofile",
        });
      } else {
        setModalConfig({
          message: "Something went wrong while checking your profile.",
          redirectPath: "/myprofile",
        });
      }
      setShowProfileModal(true);
    }
  };  
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
    
    if (file && allowedTypes.includes(file.type)) {
      setSelectedFile(file);
      setError(null);
    } else {
      setError("Invalid file type. Please upload a PDF or Word document.");
      setSelectedFile(null);
    }
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError("Please select a file to upload.");
      return;
    }

    setUploading(true);
    setError(null);
    setUploadSuccess(false);

    const formData = new FormData();
    formData.append("cv", selectedFile);
    let userId = localStorage.getItem("userid"); 

  if (!userId || userId === "null" || userId === "undefined") {
    setError("User not found. Please log in again.");
    setUploading(false);
    return;
  }

  formData.append("userId", userId);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}candidate_details/upload-cv`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      setUploadSuccess(true);
      setShowModal(true);
      setSelectedFile(null);
    } catch (err) {
      setError("Failed to upload file. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    checkProfileCompleteness();
  }, []);

  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">CV Manager</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">CV Manager</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="CV Manager"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "CV Manager", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <CandidateDashboardNav />
            {/* here page will is design */}
            <div className='col-md-9'>
            <h5 className="mb-3">CV Manager</h5>
            <hr />
              <div className="card p-4">
                
              <div className="border border-2 border-dotted p-5 text-center rounded bg-light">
                  <FaCloudUploadAlt size={40} className="text-primary mb-2" />
                  <p className="mb-2 fw-bold">Upload File Here</p>
                  <small className="text-muted">
                    To upload file size is (Max 5Mb) and allowed file types are (.doc, .docx, .pdf)
                  </small>
                  <input 
                    type="file" 
                    accept=".pdf,.doc,.docx" 
                    className="d-none" 
                    ref={fileInputRef} 
                    onChange={handleFileChange} 
                  />

                  <div className="d-flex justify-content-center mt-3">
                    <button className="btn btn-outline-primary btn-lg d-flex align-items-center gap-2 upload-btn"
                     onClick={handleUploadClick}
                     >
                      <FaCloudUploadAlt />
                      {selectedFile ? "Choose File" : "Choose File"}
                    </button>
                  </div>
                  {selectedFile && (
                    <p className="mt-2 text-success">{selectedFile.name}</p>
                  )}

                  {/* Upload Button */}
                  {selectedFile && (
                    <div className="d-flex justify-content-center mt-3">
                      <button 
                        className="btn btn-primary btn-lg d-flex align-items-center gap-2"
                        onClick={handleUpload}
                        disabled={uploading}
                      >
                        <FaCloudUploadAlt />
                        {uploading ? "Uploading..." : "Upload"}
                      </button>
                    </div>
                  )}

                  
                  {error && <p className="text-danger mt-2">{error}</p>}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        show={showModal}
        onClose={() => setShowModal(false)}
        success={true}
        message="CV uploaded successfully!"
      />
      <ProfileModal
        show={showProfileModal}
        onClose={() => navigate("/myprofile")}
        message={modalConfig.message}
        redirectPath={modalConfig.redirectPath}
      />
    </>
  )
}

export default CV_Manager